import { Filter } from '@juristat/common/types'

const removeKey = <K extends Filter>(key: K, { [key]: _, ...obj }: WeakObject) => ({
  ...obj,
})

export default removeKey
